// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2T4uy","label":"Labeled_label__1bPNH","divider":"Labeled_divider__1oJyW"};